import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { DataServiceEntity } from '../../data-services/data-service.entity';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Table } from '../../shared/efaact-primeng.module';
import { IUserInfo } from '../../user-info';
import * as fromDataServices from '../../data-services';

@Component({
    selector: 'ef-reconciliation-file-format',
    templateUrl: './reconciliation-file-format.component.html',
    styleUrls: ['./reconciliation-file-format.component.scss'],
    standalone: false
})
export class ReconciliationFileFormatComponent implements OnInit {
    @Input()
    public items: fromDataServices.Reconciliation.Fields.ReconciliationFieldModel[];
    @Output() FieldSelected =
        new ReplaySubject<fromDataServices.Reconciliation.Fields.ReconciliationFieldModel>(
            1
        );
    @Output() GroupSelected = new ReplaySubject(1);
    @Output() RowReorder = new ReplaySubject<
        fromDataServices.Reconciliation.Fields.ReconciliationFieldModel[]
    >(1);
    @ViewChild('fileFormat', { static: true }) table: Table;
    protected editing: fromDataServices.Reconciliation.Fields.ReconciliationFieldModel =
        {} as any;
    constructor(private log: LoggingService) {}

    ngOnInit(): void {
        this.RowReorder.next(this.items);
    }
    onRowReorderHandler($event) {
        this.RowReorder.next(this.table.value);
    }
    onRowEditSave(
        item: fromDataServices.Reconciliation.Fields.ReconciliationFieldModel
    ) {
        this.log.verbose({
            type: 'ReconciliationFileFormatComponent:onRowEditSave',
            item
        });
        this.FieldSelected.next(item);
        if (item.PropertyType.toLocaleLowerCase() === 'group') {
            this.GroupSelected.next();
        }
    }

    shouldDisable = (
        item: fromDataServices.Reconciliation.Fields.ReconciliationFieldModel
    ) => {
        switch (item.PropertyName) {
            case 'QBPayrollAmount':
                return this.items.some(
                    i =>
                        i.PropertyName === 'EmployeeWorkDate' &&
                        i.InUse === true
                );
                break;
            case 'EmployeeWorkDate':
                return this.items.some(
                    i =>
                        i.PropertyName === 'QBPayrollAmount' &&
                        i.InUse === true
                );
                break;

            default:
                return false;
        }
    };
}
